import CustomCategoriesByIdReducer from "@tecumseh/Store/Reducer/CustomCategoriesByIdReducer";
import CustomContentsSearchReducer from "@tecumseh/Store/Reducer/CustomContentSearchReducer";
import CustomDocumentsSearchReducer from "@tecumseh/Store/Reducer/CustomDocumentsSearchReducer";
import CustomPageLinksReducer from "@tecumseh/Store/Reducer/CustomPageLinksReducer";
import CustomReplaceProductReducer from "@tecumseh/Store/Reducer/CustomReplaceProductReducer";
import RoleBasePageReducer from "@tecumseh/Store/Reducer/CustomRoleBasePageReducer";
import CustomSearchResultTabsReducer from "@tecumseh/Store/Reducer/CustomSearchResultTabsReducer";
import PerformanceWidgetReducer from "@tecumseh/Store/Reducer/PerformanceWidgetReducer";
import PIMExportHistoryReducer from "@tecumseh/Store/Reducer/PIMExportHistoryReducer";
import PIMExportReducer from "@tecumseh/Store/Reducer/PIMExportReducer";
import PIMGetAttributesReducer from "@tecumseh/Store/Reducer/PIMGetAttributesReducer";
import PIMGetTemplateListReducer from "@tecumseh/Store/Reducer/PIMGetTemplateListReducer";
import ProductVairantReducer from "@tecumseh/Store/Reducer/ProductVairantReducer";
import { combineReducers } from "redux";

const customDataReducerData = {
    productVairant: ProductVairantReducer,
    documentsSearch: CustomDocumentsSearchReducer,
    contentSearch: CustomContentsSearchReducer,
    searchResultsTab: CustomSearchResultTabsReducer,
    customCategoriesById: CustomCategoriesByIdReducer,
    performanceWidgetLoaded: PerformanceWidgetReducer,
    roleBasePages: RoleBasePageReducer,
    autheticatedPages: CustomPageLinksReducer,
    replaceProductDetail: CustomReplaceProductReducer,
    exportHistory: PIMExportHistoryReducer,
    pimAttributes: PIMGetAttributesReducer,
    PimExport: PIMExportReducer,
    pimCustomerTemplateList : PIMGetTemplateListReducer
};

export type DataReducers = typeof customDataReducerData;

const customDataReducer = combineReducers(customDataReducerData as any);

export default customDataReducer;
